import { Directive, ElementRef, Output, EventEmitter } from '@angular/core';

const DIMENSION = 20;

@Directive({
  selector: '[size-detector]'
})
export class SizeDetectorDirective {

  constructor(private elementRef: ElementRef<HTMLElement>) { 
    
  }


  @Output() onSettingsEvent = new EventEmitter<{ blockWidth: number, blockHeight: number, m: number, n: number }>()

  ngOnInit(): void {


    setTimeout(() => {
      let div = this.elementRef.nativeElement
      console.log('blockWidth:', Math.floor(div.clientWidth / DIMENSION) -2,
        'blockHeight:', Math.floor((div.clientHeight)) / (div.clientHeight / DIMENSION),
        'm:', DIMENSION,
        'n:', DIMENSION)
  
        console.log("the divr itself, ", this.elementRef)
  
      this.onSettingsEvent.emit({
        blockWidth: Math.floor(div.clientWidth / DIMENSION) -2,
        blockHeight: Math.floor(div.clientWidth / DIMENSION) -2,
        m: DIMENSION,
        n: DIMENSION
      })
    }, 0);


  }

  

}